import { useRoutes } from 'react-router-dom';

// routes
import MainRoutes from './MainRoutes';
import AuthenticationRoutes from './AuthenticationRoutes';
import config from 'config';
import { getToken } from 'services/auth';
import { useSnackbar } from 'notistack';
import SnackbarUtils from 'views/components/SnackbarUtils';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    const isLoggedIn = getToken();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    SnackbarUtils.setSnackBar(enqueueSnackbar,closeSnackbar);
    return useRoutes(MainRoutes(isLoggedIn), config.basename);
}
